var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportTeel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 1.99999C6.96513 1.99999 6.66667 1.70151 6.66667 1.33332C6.66667 0.965136 6.96513 0.666656 7.33333 0.666656H11.3333C11.5101 0.666656 11.6797 0.736897 11.8047 0.861916C11.9297 0.986943 12 1.15651 12 1.33332V5.33333C12 5.70153 11.7015 5.99999 11.3333 5.99999C10.9651 5.99999 10.6667 5.70153 10.6667 5.33333V2.94281L8.02312 5.58634C7.76276 5.84667 7.34066 5.84667 7.0803 5.58634C6.81996 5.32601 6.81996 4.90387 7.0803 4.64354L9.72387 1.99999H7.33333ZM0 3.33333C0 2.59695 0.596953 1.99999 1.33333 1.99999H4.66667C5.03487 1.99999 5.33333 2.29847 5.33333 2.66666C5.33333 3.03485 5.03487 3.33333 4.66667 3.33333H1.33333V11.3334H9.33333V7.99999C9.33333 7.63179 9.6318 7.33333 10 7.33333C10.3682 7.33333 10.6667 7.63179 10.6667 7.99999V11.3334C10.6667 12.0698 10.0697 12.6667 9.33333 12.6667H1.33333C0.596953 12.6667 0 12.0698 0 11.3334V3.33333Z",
    fill: "#2BBACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportTeel);
export default __webpack_public_path__ + "static/media/export-teel.3ae2658550448550618e53c0de98cf7a.svg";
export { ForwardRef as ReactComponent };